export default {
	getSearchDates_({ searchParams: { strDt, endDt } }) {
		return [strDt, endDt];
	},
	isWriterSelf_({ detailForm: { apcnId, rgnId } }, getters, { commonStore }) {
		if (!rgnId) return true;
		return window.atob(commonStore.user.userId) === apcnId;
	},
	getFindPopupSearchDates_({ findPopupSearchParams: { strDt, endDt } }) {
		return [strDt, endDt];
	},
	//ISIR상태(조회조건) selectBox
	getIsirCsetScnCdList2_({ isirCsetScnCdList2 }) {
		const list = [];
		// console.log('isirCsetScnCdList2 >>>', isirCsetScnCdList2);
		isirCsetScnCdList2.length && isirCsetScnCdList2.forEach(row => list.push({ label: row.label, value: row.value }));
		return list;
	},
	getIsirCsetScnNm_({ detailForm: { isirCsetScnCd }, isirCsetScnCdList }) {
		const filtered = isirCsetScnCdList.length && isirCsetScnCdList.filter(el => el.value === isirCsetScnCd);
		return filtered[0]?.label;
	},
	getpartClCdListFiltered_({ partClCdList }) {
		return partClCdList.filter(el => el.value === 'FL' || el.value === 'RC'); //FL : 초도품, RC : 양산품
	},
	isNew_({ detailForm: { altrNo, pgsStCd } }) {
		return !altrNo && !pgsStCd;
	},
	getSndStCdListFiltered_({ sndStCdList }) {
		return sndStCdList.filter(el => el.value === 'NSND' || el.value === 'ET_FAIL'); //ET_FAIL : 발송실패, NSND : 미발송
	},
	detailFormData_({ detailForm }) {
		const formData = new FormData();
		for (const [key, val] of Object.entries(detailForm)) {
			if (!val) continue;
			else if (key === 'altrFile' || key === 'vrfFile') {
				val.length ? val.forEach(file => formData.append(key, file)) : formData.append(key, '');
			} else if (key === 'altrPreFile' || key === 'altrAftFile') {
				formData.set(key, val);
			} else formData.append(key, val);
		}
		return formData;
	},
	detailFormUpdate_({ detailForm }, getters) {
		const {
			partNo,
			altrNo,
			altrTypeCd,
			altrPrvsLgrpCd,
			altrPrvsSgrpCd,
			isirCsetScnCd,
			rmk,
			vrfRsltCd,
			pgsStCd,
			affrPrcsId,
			altrPreFileId,
			altrAftFileId,
			vrfFileId,
			altrFileId,
			dsprNm,
			dsprAdr,
			dsprId,
			altrPurpSbc,
			altrSbc,
			rcptNm,
			rcptAdr,
			rfpNm,
			rfpAdr
		} = detailForm;
		return {
			partNo,
			altrNo,
			altrTypeCd,
			altrPrvsLgrpCd,
			altrPrvsSgrpCd,
			isirCsetScnCd,
			rmk,
			affrPrcsId,
			vrfRsltCd,
			pgsStCd,
			altrPreFileId,
			altrAftFileId,
			vrfFileId,
			altrFileId,
			dsprNm,
			dsprAdr,
			dsprId,
			altrPurpSbc,
			altrSbc,
			rcptNm,
			rcptAdr,
			rfpNm,
			rfpAdr
		};
	},
	getColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000956'), //품번
				prop: 'partNo',
				minWidth: '150px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000006'), //변경번호
				prop: 'altrNo',
				minWidth: '150px',
				custom: true,
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001086'), //변경유형
				prop: 'altrTypeNm',
				minWidth: '90px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001122'), //대분류
				prop: 'altrPrvsLgrpNm',
				minWidth: '150px',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001123'), //소분류
				prop: 'altrPrvsSgrpNm',
				minWidth: '150px',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000027'), //ISIR 구분
				prop: 'isirCsetScnNm',
				minWidth: '130px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001094'), //진행상태
				prop: 'pgsStNm',
				minWidth: '80px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001742'), //변경일
				prop: 'altrDd',
				minWidth: '120px',
				align: 'center'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001089'), //납품일
				prop: 'altrDlvgDd',
				minWidth: '120px',
				align: 'center'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001125'), //결과
				prop: 'vrfRsltNm',
				minWidth: '80px',
				align: 'center'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000982'), //담당자
				prop: 'apcnNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001092'), //검토자
				prop: 'vrfNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001384'), //검토일
				prop: 'vrfFinDd',
				minWidth: '120px',
				align: 'center'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001093'), //승인자
				prop: 'csetNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000012'), //승인일
				prop: 'csetFinDd',
				minWidth: '120px',
				align: 'center'
			}
		];
	},
	getPopColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000956'), //품번
				prop: 'partNo',
				minWidth: '150px',
				custom: true,
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000957'), //품명
				prop: 'partNm',
				minWidth: '150px',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000006'), //변경번호
				prop: 'altrNo',
				minWidth: '150px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001086'), //변경유형
				prop: 'altrTypeNm',
				minWidth: '90px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001122'), //대분류
				prop: 'altrPrvsLgrpNm',
				minWidth: '110px',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001123'), //소분류
				prop: 'altrPrvsSgrpNm',
				minWidth: '110px',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000027'), //ISIR 구분
				prop: 'isirCsetScnNm',
				minWidth: '100px',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001094'), //진행상태
				prop: 'pgsStCd',
				minWidth: '80px',
				form: {
					type: 'select',
					options: state.pgsStEmCdList,
					placeholder: ' ',
					isDisabled: () => true
				},
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001742'), //변경일
				prop: 'altrDd',
				minWidth: '120px',
				align: 'center'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001852'), //부품구분
				prop: 'partGCd',
				minWidth: '100px',
				form: {
					type: 'select',
					options: state.partGCdList,
					placeholder: ' ',
					isDisabled: () => true
				},
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001341'), //납품업체
				prop: 'cofNm',
				minWidth: '100px',
				sortable: false
			}
		];
	}
};
